import { render, staticRenderFns } from "./ResultsCardView.vue?vue&type=template&id=bc38ff1e"
import script from "./ResultsCardView.vue?vue&type=script&lang=js"
export * from "./ResultsCardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports